module.exports = __webpack_public_path__ + "img/solidworks_preview.71f3e9a4.jpg";